import { $auth } from 'ziphy-web-shared/basic/entities/auth'

// () => ({onClick, wvAction})
export const customActions = {
  HANDLE_REJECT_PAPERWORK: () => ({
    onClick: async () => await $auth.logout(),
  }),
}
